var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showGrid
    ? _c(
        "div",
        { staticClass: "k-card-grid" },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in", appear: "" } },
            [
              _vm.isLoading
                ? _c(
                    "ul",
                    { key: "loading", style: _vm.gridStyle },
                    _vm._l(_vm.skeletonCount, function (i) {
                      return _c("SkeletonCard", {
                        key: i,
                        attrs: {
                          height: _vm.skeletonHeight,
                          orientation: _vm.skeletonOrientation,
                          thumbnailDisplay: _vm.skeletonThumbnailDisplay,
                          thumbnailAlign: _vm.skeletonThumbnailAlign,
                        },
                      })
                    }),
                    1
                  )
                : _c(
                    "ul",
                    { key: "loaded", style: _vm.gridStyle },
                    [_vm._t("default")],
                    2
                  ),
            ]
          ),
          _vm.debug
            ? _c("div", { staticClass: "k-debug" }, [
                _c("div", [_vm._v("DEBUG")]),
                _c("div", [
                  _vm._v("breakpoint: " + _vm._s(_vm.windowBreakpoint)),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }